import './App.css';
import Navbar  from "./components/Navbar"
import Hero from "./components/Hero";
import Services from "./components/Services";
import Footer from "./components/Footer";
import Testimonials from "./components/Testimonials"
import FloatingButtons from './components/FloatingButtons';
import Portfolio from './components/Portfolio';
import About from "./components/About";
import Contact from "./components/Contact";

function App() {
  return (
    <div className="App">
     <Navbar/>
     <Hero/>
     <About/>
     <Portfolio/>
     <Services/>
     <Testimonials/>
      <Contact/>
     <FloatingButtons/>
     <Footer/>
    </div>
  );
}

export default App;
